/**
 * ## Modal window manager component
 *
 * @module src/components/modal
 */

"use strict";

const xss = require("xss");

const conf = require("../../config");
const loc = require("../../controllers/location");
const layout = require("../layout");
const tabs = require("../../controllers/tabs");
const component = require("../../components/component");
const notification = require("../../components/notification");
const print = require("../../components/print");
const moment = require("moment-timezone");
const l = require("../../common").localization;
const availability = require("../../common").availability;

let kd;

let resDate = parseInt(moment().startOf("day").format("X"), 10);
let resTime = null;
let resAvailable = false;

let preSelect = {
  active: false,
  tables: [],
};

const init = (kdObj) => {
  kd = kdObj;
  kd.on("modal", (modalData) => {
    create(modalData.opt, modalData.data, (err, value) => {
      destroy();
    });
  });
};

const formatCell = (cell) => {
  if (cell.length === 10) {
    return `(${cell.substring(0, 3)}) ${cell.substring(3, 6)}-${cell.substring(
      6,
      10
    )}`;
  }
  return cell;
};

/**
 * create
 */
const create = (options, data, callback) => {
  const returnData = {};
  $(".modal_base").css("display", "none");
  $("#modal_block").css("display", "block");

  TweenMax.set("#modal", {
    transformOrigin: "50% 50%",
  });
  if (
    conf.vars.NODE_ENV.indexOf("ios") > -1 ||
    conf.vars.NODE_ENV.indexOf("android") > -1
  ) {
    TweenMax.set("#modal", {
      y: 25,
    });
  }
  if (options.width) {
    TweenMax.to("#modal", 0, {
      width: options.width,
    });
  }
  if (options.height) {
    TweenMax.to("#modal", 0, {
      height: options.height,
    });
  }
  switch (options.type) {
    case "dialog": {
      $("#dialog").css("display", "block");
      $("#modal_dialog_h1").html(options.h1);
      $("#modal_dialog_body").html(options.body);

      let fields = "";
      let c = 0;
      if (options.hasOwnProperty("fields")) {
        options.fields.forEach((field) => {
          ++c;
          fields += `<input type="text" class="textbox_single theme_bg_charcoal" \
                    id="field${c}" name="field${c}" placeholder="${field.description}">`;
        });
        fields += '<div class="clear"></div>';
      }
      $("#modal_dialog_fields").html(fields);

      let buttons = "";
      c = 0;
      options.buttons.forEach((button) => {
        ++c;
        let btnclass = "btn8";
        if (c === options.buttons.length) {
          btnclass = "btn7";
        }
        buttons += `<div class="${btnclass} modal_dialog_button" id="modal_dialog_button${c}" \
                data-value="${button.value}">${button.description}</div>`;
      });
      buttons += '<div class="clear"></div>';
      $("#modal_dialog_buttons").html(buttons);
      layout.resize();
      $(".modal_dialog_button").unbind();
      $(".modal_dialog_button").fastClick((e) => {
        // event, type, data to create component, return value to populate
        e.stopPropagation();
        if (options.fields) {
          c = 0;
          returnData.fields = [];
          options.fields.forEach((field) => {
            ++c;
            returnData.fields.push($(`#field${c}`).val());
          });
        }
        returnData.button = $(`#${e.target.id}`).data("value");

        callback(null, returnData);
      });
      if (options.hasOwnProperty("fields")) {
        $("#field1").focus();
      }
      break;
    }
    case "settings": {
      $("#dialog").css("display", "block");
      $("#modal_dialog_h1").html(options.h1);
      $("#modal_dialog_body").html(options.body);

      let content = "";
      content += '<div id="modal_settings_box">';
      content += '<div class="modal_settings_item">';
      content += `${l.translate("Interface Speed:")} `;
      content += '<div id="modal_settings_interface">';
      switch (conf.vars.interfaceSpeed.toString()) {
        case "0": {
          content += `${l.translate(
            "Instant (use for lower performance devices)"
          )}`;
          break;
        }
        case "0.5": {
          content += `${l.translate("Standard")}`;
          break;
        }
        case "1": {
          content += `${l.translate("Smooth")}`;
          break;
        }
        default: {
          break;
        }
      }
      content += ' <i class="fa fa-angle-down fa-lg"></i>';
      content += "</div>";
      content += "</div>";
      content += '<div class="modal_settings_item">';
      content += `${l.translate("Language:")} `;
      content += '<div id="modal_settings_language">';
      let language = "en";
      if (window.localStorage.getItem("language")) {
        language = window.localStorage.getItem("language");
      }
      for (let i = 0; i < conf.vars.languages.length; ++i) {
        if (language === conf.vars.languages[i].value) {
          content += `${conf.vars.languages[i].description}`;
          break;
        }
      }
      content += ' <i class="fa fa-angle-down fa-lg"></i>';
      content += "</div>";
      content += "</div>";
      content += "</div>";
      $("#modal_dialog_fields").html(content);

      $("#modal_settings_interface").unbind();
      $("#modal_settings_interface").fastClick((e) => {
        const interfacedrop = [
          {
            description: l.translate(
              "Instant (use for lower performance devices)"
            ),
            value: "0",
          },
          {
            description: l.translate("Standard"),
            value: "0.5",
          },
          {
            description: l.translate("Smooth"),
            value: "1",
          },
        ];
        const options2 = {
          target_id: "modal_settings_interface",
          type: "dropdown",
          position: "bottom",
          highlight: null,
          adjust: {
            x: -30,
            y: -10,
          },
        };
        component.create(options2, interfacedrop, (err, value) => {
          window.localStorage.setItem("interfaceSpeed", Number(value.value));
          let result = "";
          switch (value.value.toString()) {
            case "0": {
              result = l.translate(
                "Instant (use for lower performance devices)"
              );
              break;
            }
            case "0.5": {
              result = l.translate("Standard");
              break;
            }
            case "1": {
              result = l.translate("Smooth");
              break;
            }
            default: {
              break;
            }
          }
          result += ' <i class="fa fa-angle-down fa-lg"></i>';
          $("#modal_settings_interface").html(result);
          conf.vars.interfaceSpeed = Number(value.value);
        });
      });

      $("#modal_settings_language").unbind();
      $("#modal_settings_language").fastClick((e) => {
        const options2 = {
          target_id: "modal_settings_language",
          type: "dropdown",
          position: "bottom",
          highlight: null,
          adjust: {
            x: 0,
            y: -10,
          },
        };
        component.create(options2, conf.vars.languages, (err2, val) => {
          window.localStorage.setItem("language", val.value);
          let loc2 = xss(window.location.href).split("?")[0];
          if (loc2.indexOf("/#") > -1) {
            loc2 = `${loc.split("/#")[0]}/`;
          }
          window.location = `${loc2}?usage=resume&jwt=${conf.vars.userdata.jwtToken}\
&site_id=${conf.vars.userdata.site_id}`;
        });
      });

      let buttons = "";
      let c = 0;
      options.buttons.forEach((button) => {
        ++c;
        let btnclass = "btn8";
        if (c === options.buttons.length) {
          btnclass = "btn7";
        }
        buttons += `<div class="${btnclass} modal_dialog_button" id="modal_dialog_button${c}" \
                data-value="${button.value}">${button.description}</div>`;
      });
      buttons += '<div class="clear"></div>';
      $("#modal_dialog_buttons").html(buttons);
      layout.resize();
      $(".modal_dialog_button").unbind();
      $(".modal_dialog_button").fastClick((e) => {
        // event, type, data to create component, return value to populate
        e.stopPropagation();
        if (options.fields) {
          c = 0;
          returnData.fields = [];
          options.fields.forEach((field) => {
            ++c;
            returnData.fields.push($(`#field${c}`).val());
          });
        }
        returnData.button = $(`#${e.target.id}`).data("value");

        callback(null, returnData);
      });
      if (options.hasOwnProperty("fields")) {
        $("#field1").focus();
      }
      break;
    }
    case "addparty": {
      let c = 0;
      let currentSize = 0;
      $("#addparty").css("display", "block");
      if (
        data.location.hasOwnProperty("beanstalk") &&
        data.location.beanstalk.length > 0 &&
        data.location.hasOwnProperty("widget") &&
        data.location.widget.hasOwnProperty("loyalty") &&
        data.location.widget.loyalty &&
        !data.hasOwnProperty("activity")
      ) {
        $("#addparty_beanstalk").css("display", "block");
      } else {
        $("#addparty_beanstalk").css("display", "none");
      }
      if (data.hasOwnProperty("activity")) {
        setMode(options.mode, true);
      } else {
        setMode(options.mode, false);
      }

      tabs.highlight(`#modal_addparty_${options.subtype}`, ".modal_tabs_base");
      $(".modal_tabs_top").unbind();
      $(".modal_tabs_top").fastClick((e) => {
        options.mode = $(`#${e.target.id}`).data("tab");
        // create(options, data, callback);
        if (data.hasOwnProperty("activity")) {
          setMode(options.mode, true);
        } else {
          setMode(options.mode, false);
        }
      });

      // layout.resize();

      tabs.highlight("#modal_addparty_basic", ".modal_tabs_sidebar");
      $(".modal_tabs_side").unbind();
      $(".modal_tabs_side").fastClick((e) => {
        e.stopPropagation();
        tabs.highlight(
          `#modal_addparty_${$(`#${e.target.id}`).data("tab")}`,
          ".modal_tabs_sidebar"
        );
        layout.resize();
      });

      $("#modal_addparty_cell").val("");
      if (data.hasOwnProperty("activity")) {
        $("#modal_addparty_btn2").html(l.translate("Save Changes"));
        $("#modal_addparty_name").val(data.activity.name);
        currentSize = data.activity.size;
        $("#modal_addparty_partysize").val(data.activity.size);
        if (data.activity.hasOwnProperty("cell") && data.activity.cell) {
          $("#modal_addparty_cell").val(formatCell(data.activity.cell));
        }
        if (data.activity.hasOwnProperty("email")) {
          $("#modal_addparty_email").val(data.activity.email);
        }
        if (data.activity.hasOwnProperty("createdBy")) {
          $("#modal_addparty_createdBy").val(data.activity.createdBy);
        }
        if (options.mode === "reservations") {
          $("#modal_addparty_cell").mask("(000) 000-0000");
        } else {
          switch (data.activity.type) {
            case 1:
            case 2: {
              $("#modal_addparty_cell").mask("(000) 000-0000");
              break;
            }
            case 3: {
              $("#modal_addparty_cell").mask("00000");
              break;
            }
            default: {
              break;
            }
          }
        }
      } else {
        $("#modal_addparty_name").val("");
        $("#modal_addparty_partysize").val(2);
        $("#modal_addparty_cell").val("");
        $("#modal_addparty_email").val("");
      }

      $("#email_address").css("display", "block");
      if (
        data.location.hasOwnProperty("emailCollection") &&
        data.location.emailCollection < 2
      ) {
        $("#email_address").css("display", "none");
      }

      $("#callahead").css("display", "block");
      if (
        data.location.hasOwnProperty("callAhead") &&
        data.location.callAhead
      ) {
        $("#callahead").css("display", "none");
      }

      $("#modal_addparty_partysize").unbind();
      $("#modal_addparty_partysize").fastClick((e) => {
        const opt = {
          target_id: e.target.id,
          targetResult: "modal_addparty_partysize",
          type: "size",
          limit: 10,
          position: "right",
          adjust: {
            x: -10,
            y: 14,
          },
        };
        /*
                component.create(options, conf.vars.partySizes, (err, value) => {
                    $('#modal_addparty_partysize').val(value.value);
                });
                */

        component.create(opt, {}, (err, value) => {
          let waitPartySize = value;
          if (!waitPartySize) {
            waitPartySize = 2;
          }
          $("#modal_addparty_partysize").val(waitPartySize);
          if (waitPartySize > 14) {
            waitPartySize = 14;
          }
          waitTime = loc.getCurrentWait(
            parseInt(waitPartySize, 10),
            $("#modal_addparty_preference").val()
          );
          conf.vars.quoteTimes.forEach((field) => {
            if (waitTime === field.value) {
              $("#modal_addparty_quoted").val(field.description);
              return;
            }
          });
          $("#modal_addparty_quoted_value").data("value", waitTime);
        });

        /*
                block.filter('layout_sidebar_content_standard', 'in');
                */
      });

      // date and time

      $("#reservation_override_box").css("display", "none");
      $("#modal_addparty_time").css("border-bottom", "4px solid #ccc");
      if (data.hasOwnProperty("activity") && options.mode === "reservations") {
        resDate = data.activity.date;
        $("#reservation_override").prop("checked", true);
      } else {
        $("#reservation_override").prop("checked", false);
        if (options.hasOwnProperty("startDate")) {
          resDate = options.startDate;
        } else {
          resDate = parseInt(moment().startOf("day").format("X"), 10);
        }
      }
      $("#modal_addparty_date").val(
        l.tcal(moment(resDate * 1000).format(l.translate("dddd, MMMM Do YYYY")))
      );

      $("#modal_addparty_date").off();
      $("#modal_addparty_date").fastClick((e) => {
        const optionsd = {
          target_id: e.target.id,
          type: "calendar",
          position: "right",
          startDate: resDate * 1000,
          adjust: {
            x: -130,
            y: 13,
          },
          kd: data.kd,
        };

        component.create(optionsd, {}, (err, value) => {
          resDate = parseInt(moment(value.date).startOf("day").format("X"), 10);
          resTime = l.translate("Select");
          $("#modal_addparty_time").val(l.translate("Select"));
          $("#modal_addparty_time").css("border-bottom", "4px solid #ccc");
          $("#modal_addparty_date").val(
            l.tcal(moment(value.date).format(l.translate("dddd, MMMM Do YYYY")))
          );
        });
      });

      if (data.hasOwnProperty("activity") && options.mode === "reservations") {
        resAvailable = true;
        resTime = data.activity.time;
        $("#addparty_send_checkin").css("display", "none");
      } else {
        if (options.hasOwnProperty("startTime")) {
          resAvailable = false;
          resTime = options.startTime;
          if (options.hasOwnProperty("available") && options.available) {
            resAvailable = true;
            $("#modal_addparty_time").css("border-bottom", "4px solid #98ff70");
          } else {
            resAvailable = false;
            $("#modal_addparty_time").css("border-bottom", "4px solid #b20002");
          }
        } else {
          resTime = l.translate("Select");
          resAvailable = false;
        }
      }
      $("#modal_addparty_date").val(
        l.tcal(moment(resDate * 1000).format(l.translate("dddd, MMMM Do YYYY")))
      );

      $("#modal_addparty_time").off();
      $("#modal_addparty_time").fastClick((e) => {
        e.stopPropagation();
        e.preventDefault();
        $("#reservation_override").prop("checked", false);
        const optionst = {
          target_id: e.target.id,
          location: data.location,
          type: "time",
          position: "right",
          availability: true,
          start: resTime,
          date: resDate,
          adjust: {
            x: -50,
            y: 13,
          },
        };
        component.create(optionst, { kd: data.kd }, (err, value) => {
          resTime = value.index;

          // console.log('matrix by date', availability.byDate(data.kd, resTime));

          $("#modal_addparty_time").val(
            indexToTime(resTime, data.location.time24)
          );
          if (value.available) {
            notification.destroy();
            resAvailable = true;
            $("#reservation_override_box").css("display", "none");
            $("#modal_addparty_time").css("border-bottom", "4px solid #98ff70");
          } else {
            // set time border to red.
            resAvailable = false;
            $("#reservation_override_box").css("display", "block");
            $("#modal_addparty_time").css("border-bottom", "4px solid #b20002");
          }
        });
      });

      $("#modal_addparty_time").val(indexToTime(resTime, data.location.time24));

      let waitTime = 0;
      if (data.hasOwnProperty("activity")) {
        waitTime = data.activity.quoted;
      } else {
        waitTime = loc.getCurrentWait(
          parseInt($("#modal_addparty_partysize").val(), 10),
          $("#modal_addparty_preference").val()
        );
      }
      $("#modal_addparty_quoted_value").data("value", waitTime);

      conf.vars.quoteTimes.forEach((field) => {
        if (waitTime === field.value) {
          $("#modal_addparty_quoted").val(field.description);
        }
      });

      $("#modal_addparty_quoted").unbind();
      $("#modal_addparty_quoted").fastClick((e) => {
        const optionsq = {
          target_id: e.target.id,
          type: "dropdown",
          position: "bottom",
          highlight: $("#modal_addparty_quoted").val(),
          adjust: {
            x: 0,
            y: -5,
          },
        };
        component.create(optionsq, conf.vars.quoteTimes, (err, value) => {
          $("#modal_addparty_quoted").val(value.description);
          $("#modal_addparty_quoted_value").data("value", value.value);
        });
        /*
            block.filter('layout_sidebar_content_standard', 'in');
            */
      });

      $("#modal_addparty_send_checkin").prop("checked", false);
      $("#addparty_send_checkin").css("display", "none");
      if (data.hasOwnProperty("activity") && options.subtype === "waitlist") {
        /*
            if (data.activity.checkin) {
                $('#modal_addparty_send_checkin').prop('checked', true);
            }
            */
      } else {
        if (data.kd.localstore.data.checkin) {
          $("#modal_addparty_send_checkin").prop("checked", true);
        }
      }
      if (data.hasOwnProperty("activity") && options.subtype === "waitlist") {
        $("#modal_addparty_alert_value").data("value", data.activity.type);
        l.toptions(conf.vars.alertTypes).forEach((field) => {
          if (data.activity.type === field.value) {
            $("#modal_addparty_alert").val(field.description);
          }
        });
        setType(data.activity.type);
      } else if (options.subtype === "waitlist") {
        $("#modal_addparty_alert_value").data("value", 1);
        $("#modal_addparty_alert").val(l.translate("Text Message"));
        setType(1);
      }

      if (options.mode === "reservations") {
        $("#addparty_send_checkin").css("display", "none");
        $("#modal_addparty_cell").css("display", "block");
        $("#modal_addparty_label_cell").css("display", "block");
      }

      // $('#modal_addparty_cell').css('display', 'block');
      // $('#modal_addparty_label_cell').css('display', 'block');
      // $('#modal_addparty_label_pager').css('display', 'none');

      $("#modal_addparty_alert").unbind();
      $("#modal_addparty_alert").fastClick((e) => {
        const opt = {
          target_id: e.target.id,
          type: "dropdown",
          position: "bottom",
          highlight: $("#modal_addparty_alert").val(),
          adjust: {
            x: 0,
            y: -5,
          },
        };
        const alertTypes = Object.assign([], l.toptions(conf.vars.alertTypes));
        if (
          data.location.hasOwnProperty("pager") &&
          data.location.pager === 0
        ) {
          alertTypes.splice(2, 1);
        }
        if (
          data.location.hasOwnProperty("emailCollection") &&
          data.location.emailCollection < 3
        ) {
          if (alertTypes.length === 5) {
            alertTypes.splice(3, 1);
          } else {
            alertTypes.splice(2, 1);
          }
        }
        component.create(opt, alertTypes, (err, value) => {
          $("#modal_addparty_alert").val(value.description);
          $("#modal_addparty_alert_value").data("value", value.value);
          setType(value.value);
        });

        /*
            block.filter('layout_sidebar_content_standard', 'in');
            */
      });

      // Needs

      $("#modal_addparty_preselect").unbind();
      $("#modal_addparty_preselect").fastClick((e) => {
        layout.hideKeyboard();
        let isMax = false;
        if (layout.getIsExpanded()) {
          isMax = true;
          layout.toggleSidebarMax();
        }
        let pass = true;
        let reserved = [];
        // populate tables that have reservations attached
        // only do it on reservation.
        if (options.mode === "reservations") {
          // get selected time on the modal form
          if (resTime === "Select" || !resTime) {
            pass = false;
            const opt = {
              position: "top",
              width: "90%",
              seconds: 5,
              h1: l.translate("Please select a time first"),
              body: l.translate(
                "Go back to the Basic Info tab and select a time for " +
                  "this reservation."
              ),
              buttons: [
                {
                  description: l.translate("ok"),
                  value: "close",
                },
              ],
            };
            notification.create(opt, {}, (err, value) => {
              notification.destroy();
            });
          }
          // LEFT OFF HERE 1234321
        }
        if (pass) {
          if (options.mode === "reservations") {
            let resID;
            if (data.hasOwnProperty("activity")) {
              resID = data.activity._id;
            }
            reserved = availability.getPreSelect(
              data.kd,
              resDate,
              resTime,
              resID
            );
          }
          $("#modal_block").css("display", "none");
          setPreSelect(reserved);
          let body;
          if (reserved.length) {
            body = l.translate(
              "Please select the tables you wish to preselect for " +
                "this party. A red table indicates it has already been selected for a " +
                "reservation during this time period. Selecting a red table may lead to " +
                "double booking.<br/><br/>" +
                "Currently Selected Tables: "
            );
          } else {
            body = l.translate(
              "Please select the tables you wish to preselect for " +
                "this party. Press `Done` when ready to return.<br/><br/>" +
                "Currently Selected Tables: "
            );
          }

          const opt = {
            position: "bottom",
            block: "full",
            width: "90%",
            color: "#ffff84",
            seconds: 0,
            h1: l.translate("Preselect Tables"),
            body,
            buttons: [
              {
                description: l.translate("Cancel"),
                value: "cancel",
              },
              {
                description: l.translate("Done"),
                value: "done",
              },
            ],
          };

          notification.create(opt, {}, (err, value) => {
            if (isMax) {
              isMax = false;
              layout.toggleSidebarMax();
            }
            $("#modal_block").css("display", "block");
            notification.destroy();
            if (value === "done") {
              // preSelect = Object.assign([], getPreSelect().tables);
              $("#modal_addparty_preselect").val(preSelect.tables.join(", "));
            } else if (value === "cancel") {
              $("#modal_addparty_preselect").val("");
              clearPreSelect(data.kd);
            }
            layout.resize();
          });
        }
      });

      $("#modal_addparty_customNotes").val("");
      $("#modal_addparty_send_confirmation").prop("checked", false);
      if (data.hasOwnProperty("activity")) {
        $("#modal_addparty_preference").val(data.activity.preference);
        if (data.activity.customNotes) {
          $("#modal_addparty_customNotes").val(data.activity.customNotes);
        }
        if (data.activity.callAhead) {
          $("#modal_addparty_callahead").prop("checked", true);
        }
        if (data.activity.hasOwnProperty("preSelect")) {
          // preSelect = Object.assign([], data.activity.preSelect);
          $("#modal_addparty_preselect").val(
            data.activity.preSelect.join(", ")
          );
          preSelect.tables = data.activity.preSelect;
        }
        /*
            if (data.activity.sendConfirmation === 1) {
                $('#modal_addparty_send_confirmation').prop('checked', true);
            }
            */
      } else {
        $("#modal_addparty_preference").val(l.translate("First Available"));
        $("#modal_addparty_preselect").val("");
        preSelect.tables = [];
      }
      $("#modal_addparty_preference").unbind();
      $("#modal_addparty_preference").fastClick((e) => {
        const opt = {
          target_id: e.target.id,
          type: "dropdown",
          position: "bottom",
          highlight: $("#modal_addparty_preference").val(),
          adjust: {
            x: 0,
            y: -5,
          },
        };
        component.create(opt, data.location.preferenceTypes, (err, value) => {
          $("#modal_addparty_preference").val(value.description);
          waitTime = loc.getCurrentWait(
            parseInt($("#modal_addparty_partysize").val(), 10),
            $("#modal_addparty_preference").val()
          );
          conf.vars.quoteTimes.forEach((field) => {
            if (waitTime === field.value) {
              $("#modal_addparty_quoted").val(field.description);
              return;
            }
          });
          $("#modal_addparty_quoted_value").data("value", waitTime);
        });
      });

      let notesHTML = "";

      if (data.hasOwnProperty("activity")) {
        c = 0;
        data.activity.notes.forEach((note) => {
          let active = "";
          if (note.active) {
            active = "checked";
          }
          notesHTML += '<div class="form_checkbox_float">';
          notesHTML += '<div class="form_checkbox">';
          notesHTML += '    <div class="squaredFour">';
          notesHTML += `        <input type="checkbox" class="squaredFour" value="1" \
                    id="modal_addparty_notes_${c}" name="modal_addparty_notes_${c}" ${active}/>`;
          notesHTML += `        <label for="modal_addparty_notes_${c}"></label>`;
          notesHTML += "    </div>";
          notesHTML += "</div>";
          notesHTML += '<div class="form_checkbox_label form_220">';
          notesHTML += note.value;
          notesHTML += "</div>";
          notesHTML += "</div>";
          ++c;
        });
      } else {
        c = 0;
        data.location.notes.forEach((note) => {
          notesHTML += '<div class="form_checkbox_float">';
          notesHTML += '<div class="form_checkbox">';
          notesHTML += '    <div class="squaredFour">';
          notesHTML += `        <input type="checkbox" class="squaredFour" value="1" \
                    id="modal_addparty_notes_${c}" name="modal_addparty_notes_${c}" />`;
          notesHTML += `        <label for="modal_addparty_notes_${c}"></label>`;
          notesHTML += "    </div>";
          notesHTML += "</div>";
          notesHTML += '<div class="form_checkbox_label form_220">';
          notesHTML += note.description;
          notesHTML += "</div>";
          notesHTML += "</div>";
          ++c;
        });
      }

      $("#modal_addparty_notes").html(notesHTML);

      // hide mode change buttons if activity exists

      if (data.hasOwnProperty("activity")) {
        if (options.mode === "waitlist") {
          if (data.activity.status >= 3) {
            $("#modal_tabs_btn1").css("display", "none");
            $("#modal_tabs_btn2").css("display", "none");
          } else {
            $("#modal_tabs_btn1").css("display", "inline-block");
            $("#modal_tabs_btn2").css("display", "none");
          }
        } else if (options.mode === "reservations") {
          $("#modal_tabs_btn1").css("display", "none");
          $("#modal_tabs_btn2").css("display", "inline-block");
        }
        $("#confirm_text").html(l.translate("Send Text w/ Changes"));
        $("#checkin_text").html(l.translate("Send Text w/ Changes"));
      } else {
        if (options.mode === "reservations") {
          $("#addparty_send_checkin").css("display", "none");
        }
        $("#modal_tabs_btn1").css("display", "inline-block");
        $("#modal_tabs_btn2").css("display", "inline-block");
        $("#checkin_text").html(l.translate("Send Check-in Text"));
        $("#confirm_text").html(l.translate("Send Text Confirmation"));
      }

      // Submit addparty form

      $(".btn_addparty").unbind();
      $(".btn_addparty").fastClick((e) => {
        e.preventDefault();
        layout.hideKeyboard();
        let trigger = [""];
        if ($(`#${e.target.id}`).data("tab") === "addparty") {
          // validation

          if (
            $("#modal_addparty_name").val() === undefined ||
            $("#modal_addparty_name").val() === ""
          ) {
            const opt = {
              position: "top",
              width: "90%",
              seconds: 3,
              h1: l.translate("Name field is required"),
              body: "",
              buttons: [
                {
                  description: l.translate("ok"),
                  value: "close",
                },
              ],
            };
            notification.create(opt, {}, (err, value) => {
              notification.destroy();
            });
          } else if (
            options.mode === "waitlist" &&
            $("#modal_addparty_alert_value").data("value") === 3 &&
            ($("#modal_addparty_cell").val() === undefined ||
              $("#modal_addparty_cell").val() === "")
          ) {
            const opt = {
              position: "top",
              width: "90%",
              seconds: 3,
              h1: l.translate("Pager number required"),
              body: "",
              buttons: [
                {
                  description: l.translate("ok"),
                  value: "close",
                },
              ],
            };
            notification.create(opt, {}, (err, value) => {
              notification.destroy();
            });
          } else if (
            options.mode === "waitlist" &&
            $("#modal_addparty_alert_value").data("value") <= 2 &&
            $("#modal_addparty_cell").cleanVal().length < 10 &&
            $("#modal_addparty_cell").cleanVal().length > 0
          ) {
            const opt = {
              position: "top",
              width: "90%",
              seconds: 3,
              h1: l.translate("Cell phone number required"),
              body: "",
              buttons: [
                {
                  description: l.translate("ok"),
                  value: "close",
                },
              ],
            };
            notification.create(opt, {}, (err, value) => {
              notification.destroy();
            });
          } else if (
            options.mode === "reservations" &&
            resTime === l.translate("Select")
          ) {
            const opt = {
              position: "top",
              width: "90%",
              seconds: 3,
              h1: l.translate("Please select a reservation start time."),
              body: "",
              buttons: [
                {
                  description: l.translate("ok"),
                  value: "close",
                },
              ],
            };
            notification.create(opt, {}, (err, value) => {
              notification.destroy();
            });
          } else if (
            options.mode === "reservations" &&
            $("#modal_addparty_cell") !== "" &&
            $("#modal_addparty_cell").cleanVal().length < 10 &&
            $("#modal_addparty_cell").cleanVal().length > 0
          ) {
            const opt = {
              position: "top",
              width: "90%",
              seconds: 3,
              h1: l.translate("Cell number required"),
              body: l.translate(
                "If any part of a cell number is entered, the full " +
                  "10-digit cell number is required"
              ),
              buttons: [
                {
                  description: l.translate("ok"),
                  value: "close",
                },
              ],
            };
            notification.create(opt, {}, (err, value) => {
              notification.destroy();
            });
          } else if (
            options.mode === "reservations" &&
            data.location.hasOwnProperty("requireCreatedBy") &&
            data.location.requireCreatedBy &&
            $("#modal_addparty_createdBy").val() === ""
          ) {
            const opt = {
              position: "top",
              width: "90%",
              seconds: 4,
              h1: l.translate(
                "Please fill in the `Created By` field with your name"
              ),
              body: "",
              buttons: [
                {
                  description: l.translate("ok"),
                  value: "close",
                },
              ],
            };
            notification.create(opt, {}, (err, value) => {
              notification.destroy();
            });
          } else if (
            ($("#modal_addparty_email").val() !== "" ||
              $("#modal_addparty_alert_value").data("value") === 4) &&
            !validateEmail($("#modal_addparty_email").val())
          ) {
            const opt = {
              position: "top",
              width: "90%",
              seconds: 3,
              h1: l.translate("Please enter a valid email address"),
              body: "",
              buttons: [
                {
                  description: l.translate("ok"),
                  value: "close",
                },
              ],
            };
            notification.create(opt, {}, (err2, value2) => {
              notification.destroy();
            });
          } else if (
            $("#modal_addparty_beanstalk").is(":checked") &&
            $("#modal_addparty_email").val() === ""
          ) {
            const opt = {
              position: "top",
              width: "90%",
              seconds: 3,
              h1: l.translate(
                "If adding to loyalty, an email address must be present."
              ),
              body: "",
              buttons: [
                {
                  description: l.translate("ok"),
                  value: "close",
                },
              ],
            };
            notification.create(opt, {}, (err2, value2) => {
              notification.destroy();
            });
          } else if (
            options.mode == "reservations" &&
            !resAvailable &&
            !$("#reservation_override").is(":checked")
          ) {
            $("#reservation_override_box").css("display", "block");
            const opt = {
              position: "top",
              width: "90%",
              seconds: 0,
              h1: l.translate("Inventory not available."),
              body: l.translate(
                "You still may book this time but it will be outside " +
                  "of the inventory and may lead to over booking. You " +
                  "must check the inventory `Override` check box and " +
                  "save again."
              ),
              buttons: [
                {
                  description: l.translate("ok"),
                  value: "close",
                },
              ],
            };
            notification.create(opt, {}, (err2, value2) => {
              notification.destroy();
            });
          } else {
            // chose text message but no cell

            if (
              ($("#modal_addparty_cell").val() === "" ||
                $("#modal_addparty_cell").val() === undefined) &&
              $("#modal_addparty_alert_value").data("value") !== 4
            ) {
              $("#modal_addparty_alert_value").data("value", 5);
            }

            // is call ahead

            let callAhead = 0;
            if ($("#modal_addparty_callahead").is(":checked")) {
              callAhead = 1;
            }

            // is send confimration

            let sendConfirmation = 0;
            let checkin = 0;
            if ($("#modal_addparty_send_confirmation").is(":checked")) {
              sendConfirmation = 1;
              trigger = ["resconfirm"];
            } else if ($("#modal_addparty_send_checkin").is(":checked")) {
              checkin = 1;
              trigger = ["checkin"];
            } else {
            }
            if (
              $("#modal_addparty_beanstalk").is(":checked") &&
              $("#modal_addparty_email").val().length > 0
            ) {
              if (trigger[0] === "checkin") {
                trigger = ["checkin", "beanstalk"];
              } else {
                trigger = ["beanstalk"];
              }
            }

            // res manager trigger
            if (
              options.mode === "reservations" &&
              !data.hasOwnProperty("activity")
            ) {
              trigger.push("resmanager");
            }

            // check notes

            c = 0;
            const notes = [];
            data.location.notes.forEach((note) => {
              if ($(`#modal_addparty_notes_${c}`).is(":checked")) {
                notes.push({
                  id: c,
                  value: note.description,
                  active: 1,
                });
              } else {
                notes.push({
                  id: c,
                  value: note.description,
                  active: 0,
                });
              }
              ++c;
            });

            let resType = 5;
            if ($("#modal_addparty_cell").val().length > 0) {
              resType = 1;
            }

            let proposed;
            let confirmText = "";
            let color = "#057ED6";
            let cell = "";
            let quoted = $("#modal_addparty_quoted_value").data("value");
            if (isNaN(quoted) || quoted === undefined) {
              quoted = 2;
            }
            if (
              $("#modal_addparty_alert_value").data("value") <= 3 &&
              $("#modal_addparty_cell").val().length > 0
            ) {
              cell = $("#modal_addparty_cell").cleanVal();
            } else if (
              options.mode === "reservations" &&
              $("#modal_addparty_cell").cleanVal().length
            ) {
              cell = $("#modal_addparty_cell").cleanVal();
            }
            if (data.hasOwnProperty("activity")) {
              if (options.mode === "waitlist") {
                confirmText = l.translate("Party details saved.");
                proposed = {
                  domain: "activity",
                  _id: data.activity._id,
                  status: data.activity.status,
                  type: $("#modal_addparty_alert_value").data("value"),
                  size: parseInt($("#modal_addparty_partysize").val(), 10),
                  name: $("#modal_addparty_name").val(),
                  cell,
                  checkin,
                  email: $("#modal_addparty_email").val(),
                  quoted,
                  callAhead,
                  preference: $("#modal_addparty_preference").val(),
                  customNotes: $("#modal_addparty_customNotes").val(),
                  notes,
                  preSelect: Object.assign([], preSelect.tables),
                  trigger,
                };
              } else if (options.mode === "reservations") {
                confirmText = l.translate("Reservation details saved.");
                proposed = {
                  domain: "reservation",
                  _id: data.activity._id,
                  type: resType,
                  size: parseInt($("#modal_addparty_partysize").val(), 10),
                  status: data.activity.status,
                  date: resDate,
                  time: resTime,
                  name: $("#modal_addparty_name").val(),
                  cell,
                  checkin,
                  email: $("#modal_addparty_email").val(),
                  preference: $("#modal_addparty_preference").val(),
                  customNotes: $("#modal_addparty_customNotes").val(),
                  notes,
                  preSelect: Object.assign([], preSelect.tables),
                  sendConfirmation,
                  requireConfirmation: 0,
                  createdBy: $("#modal_addparty_createdBy").val(),
                  trigger,
                };
              }
            } else {
              if (options.mode === "waitlist") {
                if ($("#modal_addparty_send_checkin").is(":checked")) {
                  data.kd.localstore.data.checkin = true;
                } else {
                  data.kd.localstore.data.checkin = false;
                }
                const rightNow = Math.floor(Date.now() / 1000);
                confirmText = l.translate("Party added to waitlist.");
                proposed = {
                  domain: "activity",
                  status: 1,
                  type: $("#modal_addparty_alert_value").data("value"),
                  statusTimes: {
                    added: rightNow,
                  },
                  size: parseInt($("#modal_addparty_partysize").val(), 10),
                  name: $("#modal_addparty_name").val(),
                  cell,
                  checkin,
                  email: $("#modal_addparty_email").val(),
                  quoted,
                  callAhead,
                  preference: $("#modal_addparty_preference").val(),
                  customNotes: $("#modal_addparty_customNotes").val(),
                  alerts: 0,
                  notes,
                  preSelect: Object.assign([], preSelect.tables),
                  trigger,
                };
              } else if (options.mode === "reservations") {
                confirmText = l.translate("Reservation added.");
                color = "#03AB5A";
                proposed = {
                  domain: "reservation",
                  type: resType,
                  status: 1,
                  size: parseInt($("#modal_addparty_partysize").val(), 10),
                  date: resDate,
                  time: resTime,
                  name: $("#modal_addparty_name").val(),
                  cell,
                  checkin,
                  email: $("#modal_addparty_email").val(),
                  preference: $("#modal_addparty_preference").val(),
                  customNotes: $("#modal_addparty_customNotes").val(),
                  notes,
                  quoted: 0,
                  preSelect: Object.assign([], preSelect.tables),
                  sendConfirmation,
                  requireConfirmation: 0,
                  reminded: 0,
                  createdBy: $("#modal_addparty_createdBy").val(),
                  trigger,
                };
              }
            }
            clearPreSelect(data.kd);
            data.kd
              .update(proposed)
              .then((result) => {
                destroy();
                if (
                  result.status === 3 &&
                  currentSize <
                    parseInt($("#modal_addparty_partysize").val(), 10)
                ) {
                  if (
                    data.hasOwnProperty("activity") &&
                    data.activity.hasOwnProperty("join") &&
                    data.activity.join.length > 0
                  ) {
                    proposed.join = data.activity.join;
                  }
                  data.kd.emit("splitOverflow", proposed);
                  const opt2 = {
                    position: "top",
                    width: "90%",
                    seconds: 0,
                    color,
                    h1: l.translate("Party size has increased"),
                    body: l.translate(
                      "If you would like to add tables to this " +
                        "party, please select them now. Press `Done` when complete."
                    ),
                    buttons: [
                      {
                        description: l.translate("Done"),
                        value: "close",
                      },
                    ],
                  };
                  notification.create(opt2, {}, (err, value) => {
                    data.kd.emit("splitOverflow", {});
                    notification.destroy();
                  });
                } else {
                  const opt = {
                    position: "top",
                    width: "90%",
                    seconds: 2,
                    color,
                    h1: confirmText,
                    body: "",
                    buttons: [
                      {
                        description: l.translate("ok"),
                        value: "close",
                      },
                    ],
                  };
                  notification.create(opt, {}, (err, value) => {
                    notification.destroy();
                  });
                }
                if (
                  data.location.hasOwnProperty("chitAutomatic") &&
                  data.location.chitAutomatic &&
                  data.location.hasOwnProperty("chitQueue") &&
                  data.location.chitQueue &&
                  !data.hasOwnProperty("activity") &&
                  proposed.domain === "activity" &&
                  proposed.status === 1
                ) {
                  const opt2 = {
                    type: "waitlist",
                    location: data.location,
                  };
                  print.create(opt2, proposed);
                }
                if (trigger.includes("beanstalk")) {
                  setTimeout(() => {
                    data.kd.aux({
                      domain: "activity",
                      _kd: {
                        site_id: data.location._id,
                      },
                      query: {
                        _id: result._id,
                      },
                    });
                  }, 5000);
                }
              })
              .catch((err) => {
                console.log("err", err);
              });
          }
        } else {
          destroy();
        }
      });

      $("#modal_addparty_name").focus();
      layout.resize();

      break;
    }
    default: {
      break;
    }
  }

  TweenMax.to("#modal", 0, {
    alpha: 0,
    scale: 0.8,
  });
  TweenMax.to("#modal", conf.vars.interfaceSpeed / 2, {
    alpha: 1,
    scale: 1,
    ease: Power2.easeOut,
  });

  $("#modal").unbind();
  $("#modal").fastClick((event) => {
    // event.stopPropagation();
  });

  $("#modal_block").unbind();
  $("#modal_block").fastClick((event) => {
    event.stopPropagation();
    if (event.target.id === "modal_block") {
      destroy();
    }
  });

  $(".squaredFour").unbind();
  $(".squaredFour").on("touchend", (e) => {
    if ($(`#${e.target.htmlFor}`).is(":checked")) {
      $(`#${e.target.htmlFor}`).prop("checked", false);
    } else {
      $(`#${e.target.htmlFor}`).prop("checked", true);
    }
  });
};

const validateEmail = (email) => {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return true;
  }
  return false;
};

const setMode = (mode, edit) => {
  switch (mode) {
    case "waitlist": {
      $("#modal_addparty_btn2").css("background-color", "#057ED6");
      if (!edit) {
        $("#modal_addparty_h1").html(`<i class="fa fa-check theme_blue"></i> \
                ${l.translate("Add Party To Waitlist")}`);
        $("#modal_addparty_btn2").html(l.translate("Add Party"));
      } else {
        $("#modal_addparty_h1").html(`<i class="fa fa-check theme_blue"></i> \
                ${l.translate("Party Details")}`);
        $("#modal_addparty_btn2").html(l.translate("Save"));
      }
      $("#modal_tabs_btn2").removeClass("modal_tabs_highlight");
      $("#modal_tabs_btn1").addClass("modal_tabs_highlight");
      $("#reservations_date_time").css("display", "none");
      $("#reservations_send_confirmation").css("display", "none");
      $("#waitlist_alert_by").css("display", "block");
      $("#reservation_created_by").css("display", "none");
      $("#waitlist_quoted_time").css("display", "block");
      if ($("#modal_addparty_alert_value").data("value") == 1) {
        $("#addparty_send_checkin").css("display", "block");
      }
      // tabs.highlight('#modal_addparty_' + $(`#${e.target.id}`).data('tab'), '.modal_tabs_base');
      break;
    }
    case "reservations": {
      $("#modal_addparty_btn2").css("background-color", "#03AB5A");
      if (!edit) {
        $("#modal_addparty_h1")
          .html(`<i class="fa fa-bookmark theme_green"></i> \
                ${l.translate("Add Reservation")}`);
        $("#modal_addparty_btn2").html(l.translate("Add Reservation"));
      } else {
        $("#modal_addparty_h1").html(`<i class="fa fa-check theme_green"></i> \
                ${l.translate("Reservation Details")}`);
        $("#modal_addparty_btn2").html(l.translate("Save"));
      }
      $("#modal_tabs_btn1").removeClass("modal_tabs_highlight");
      $("#modal_tabs_btn2").addClass("modal_tabs_highlight");
      $("#reservations_date_time").css("display", "block");
      $("#reservations_send_confirmation").css("display", "block");
      $("#modal_addparty_date_send_confirmation").css("display", "block");
      $("#waitlist_alert_by").css("display", "none");
      $("#reservation_created_by").css("display", "block");
      $("#waitlist_quoted_time").css("display", "none");
      $("#addparty_send_checkin").css("display", "none");
      break;
    }
    default: {
      break;
    }
  }

  layout.resize();
};

const setType = (type) => {
  switch (type) {
    case 1:
      $("#modal_addparty_cell").css("display", "block");
      $("#modal_addparty_label_cell").css("display", "block");
      $("#modal_addparty_label_pager").css("display", "none");
      $("#addparty_send_checkin").css("display", "block");
      $("#modal_addparty_cell").mask("(000) 000-0000");
      break;
    case 2:
      $("#modal_addparty_cell").css("display", "block");
      $("#modal_addparty_label_cell").css("display", "block");
      $("#modal_addparty_label_pager").css("display", "none");
      $("#addparty_send_checkin").css("display", "none");
      $("#modal_addparty_cell").mask("(000) 000-0000");
      break;
    case 3:
      $("#modal_addparty_cell").css("display", "block");
      $("#modal_addparty_label_cell").css("display", "none");
      $("#modal_addparty_label_pager").css("display", "block");
      $("#addparty_send_checkin").css("display", "none");
      $("#modal_addparty_cell").mask("00000");
      break;
    case 4:
    case 5:
      $("#modal_addparty_cell").css("display", "none");
      $("#modal_addparty_label_cell").css("display", "none");
      $("#modal_addparty_label_pager").css("display", "none");
      $("#addparty_send_checkin").css("display", "none");
      break;
    default:
      break;
  }
};

const indexToTime = (index, timeFormat) => {
  if (index === l.translate("Select")) {
    return l.translate("Select");
  }
  const hh = Math.floor(index / 4);
  const mm = `0${(index % 4) * 15}`.slice(-2);
  if (!timeFormat) {
    return moment(`${hh}:${mm}`, "HH:mm").format(l.translate("h:mm a"));
  }
  return moment(`${hh}:${mm}`, "HH:mm").format("H:mm");
};

const destroy = () => {
  component.destroy();
  clearPreSelect();
  $("#modal_block").css("display", "none");
};

const setPreSelect = (reserved) => {
  preSelect = {
    active: true,
    tables: [],
    reserved: [],
  };
  if (reserved && reserved.length) {
    preSelect.reserved = reserved;
  }
  kd.emit("preSelect", preSelect);
};

const getPreSelect = () => {
  return preSelect;
};

const clearPreSelect = () => {
  if (preSelect.active) {
    preSelect = {
      active: false,
      tables: [],
    };
    kd.emit("preSelect", preSelect);
  }
};

const addPreSelect = (table) => {
  if (!preSelect.tables.includes(table)) {
    preSelect.tables.push(table);
    kd.emit("preSelect", preSelect);
    return true;
  }
  return false;
};

module.exports = {
  init,
  create,
  destroy,
  getPreSelect,
  addPreSelect,
  clearPreSelect,
  setType,
};



/** WEBPACK FOOTER **
 ** ./src/components/modal/index.js
 **/